import React from 'react';
import { IIconProps } from './utils';

export const ExternalLink = ({
  fill = 'currentColor',
  height = 30,
  width = 30,
  ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M15 15L25 5M25 5H18.75M25 5V11.25M13.75 5H8.75C6.67893 5 5 6.67893 5 8.75V21.25C5 23.3211 6.67893 25 8.75 25H21.25C23.3211 25 25 23.3211 25 21.25V16.25"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </svg>
);
